import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=66c54b7c&scoped=true&"
import script from "./ExpandableList.vue?vue&type=script&lang=ts&"
export * from "./ExpandableList.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=66c54b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c54b7c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCheckbox: require('/var/www/packages/theme/components/atoms/CheckboxComponent/Checkbox.vue').default,IconsChevronDownIcon24px: require('/var/www/packages/theme/components/icons/chevron-down/ChevronDownIcon24px.vue').default})
